module.exports = __webpack_public_path__ + "assets/img/template-introduce-list-3.6a306ce9.png";